import React from "react";

import Button, { ButtonProps } from "./Button";

const GhostButton: React.FC<ButtonProps> = (props) => {
  return <Button variant="ghost" {...props} />;
};

export default GhostButton;
